<script setup>
import {
  StealieButton,
  StealieHeading,
  StealieOverline,
  StealieTextInput,
  StealieParagraph,
  StealieLink,
} from "@get-overalls/fe-stealie";
import SignInLayout from "@/layouts/SignInLayout.vue";
import { useForgotPassword } from "./composables/useForgotPassword";
import FormError from "@/components/FormError.vue";

const { formData, errors, submitError, formSubmitted, handleSubmit } =
  useForgotPassword();
</script>

<template>
  <SignInLayout>
    <div data-sr-unmask>
      <div>
        <StealieOverline>Reset Password</StealieOverline>
      </div>
      <div class="col-span-4">
        <StealieHeading size="lg" class="mb-6 text-balance"
          >We've got you covered!</StealieHeading
        >
      </div>
      <section v-if="!formSubmitted">
        <form
          aria-label="Forgot password form"
          method="post"
          novalidate
          class="flex flex-col gap-6"
          @submit.prevent="handleSubmit"
        >
          <div>
            <StealieTextInput
              v-model="formData.email"
              name="email"
              type="email"
              label="Work Email"
              autocomplete="email"
              required
              :error-message="errors.email"
            />
          </div>
          <FormError v-if="submitError" :error="submitError" />
          <div>
            <StealieButton type="submit" class="mt-2 mb-6" full-width
              >Send email</StealieButton
            >
          </div>
        </form>
        <div>
          <StealieParagraph size="sm" class="mb-4">
            New to Overalls?
            <StealieLink :to="{ name: 'SignUp' }" underline>Sign up</StealieLink>
          </StealieParagraph>
          <StealieParagraph size="sm">
            Already have an account?
            <StealieLink :to="{ name: 'SignIn' }" underline>Sign in</StealieLink>
          </StealieParagraph>
        </div>
      </section>
      <section v-else>
        <StealieParagraph class="mb-6 text-pretty"
          >If your email address exists in our database, you will receive a password
          recovery link at your email address in a few minutes.</StealieParagraph
        >
        <StealieLink :to="{ name: 'SignIn' }" underline>Return to sign in</StealieLink>
      </section>
    </div>
  </SignInLayout>
</template>
